import BrowseByLocation from "@/features/browse-page/components/browse-by-location-page/BrowseByLocation";
import React from "react";

export const BrowseByLocationPage = () => {
  return (
    <div>
      <BrowseByLocation />
    </div>
  );
};
